module.exports = __webpack_public_path__ + "static/media/logo.5f994727.svg";